import { BOGeneralValues } from "./BOGeneralValues.model";

export class BOComplicationMedicDiagnostic extends BOGeneralValues{
    id:number;
    diseaseCode:string;
    orphanDisease:string;
    diseaseName:string;
}